@if (briefing) {
    @if (briefing.deliveryMethod === deliveryMethods.ONLINE) {
        <div class="agpr-briefing-pdfIframe">
            <iframe
                id="briefing_pdf_iframe"
                width="1110px"
                height="100%"
                allowfullscreen
                frameborder="0"
                sandbox="allow-same-origin allow-popups allow-top-navigation allow-popups-to-escape-sandbox allow-scripts allow-downloads allow-forms allow-modals"
                scrolling="no"
            >
            </iframe>
        </div>
    }

    <main
        [id]="id"
        class="agpr-briefing"
        [agprLoading]="loadingTemplates || loadingCuratedMentions || loadingBriefing"
    >
        <div class="agpr-briefing-container">
            <section
                class="agpr-briefing-content"
                [attr.aria-label]="'Common.layout.main' | localize"
            >
                <h2
                    class="agpr-briefing-name"
                    [ngClass]="{'agpr-briefing-name--visible': !!briefing.name}"
                >
                    <span [class]="briefing?.deliveryMethod === deliveryMethods.ONLINE ? 'fa-duotone fa-regular fa-frame' : 'fa-solid fa-envelope'"></span>
                    @if (briefing.name) {
                        <span class="agpr-briefing-name-text"> {{ briefing.name }} </span>&nbsp;
                    }
                    <span class="u-srOnly">{{'Monitor.primaryHeading.briefing' | localize }}</span>
                </h2>
                <agpr-briefing-steps-navigation
                    class="agpr-briefing-stepsNavigation"
                    [selectedTabIndex]="currentStep"
                    [allErrors]="bannerErrorList"
                    (selectedTabIndexChange)="changeStep($event)"
                >
                    <agpr-briefing-compose-tab
                        #briefingComposeTab
                        noScrollPanelContent
                        [id]="briefingStepIds.compose"
                        [heading]="'Monitor.briefings.stepsNavigation.compose'"
                        [selectedTabIndex]="selectedTabIndex"
                        [sortToolTabIndex]="sortToolTabIndex"
                        [showNoBlocksSelectedErrorMsg]="showNoBlocksSelectedErrorMsg"
                        [loadingBriefing]="loadingBriefing"
                        [briefing]="briefing"
                        (scrollToAddedBlock)="scrollToAddedBlock($event)"
                        (selectedMentionChange)="selectedMentionChange($event)"
                        (selectBlockEditTab)="selectBlockEditTab()"
                        (doDraggingMentions)="onDraggingMentions($event)"
                        [ngClass]="{
                            'agpr-briefing-composeFullHeight': currentStep === briefingSteps.compose
                        }"
                        [inlineAdderAdjustment]="true"
                        actionMenuTextAlignment="left"
                    >
                    </agpr-briefing-compose-tab>
                    <agpr-tab
                        #publishingSettingsTab
                        [id]="briefingStepIds.publishingSettings"
                        [heading]="'Monitor.briefings.stepsNavigation.publishing'"
                    >
                        <agpr-briefing-publishing-step
                            [reservedUrl]="reservedUrl"
                            [draftPublished]="draftPublished"
                            [showErrors]="showErrors"
                            [publishDraftInProgress]="publishDraftInProgress"
                            [deliverySchedulerInputFields]="deliverySchedulerInputFields"
                            [requireAutomaticInsightGen]="requireAutomaticInsightGen"
                            [cachedSchedulingType]="cachedSchedulingType"
                            (publishDraft)="publishDraft()"
                            (changes)="briefingChanged()"
                            (publishingErrors)="setPublishingErrors($event)"
                        ></agpr-briefing-publishing-step>
                    </agpr-tab>
                    <agpr-tab
                        #reviewScheduleTab
                        [id]="briefingStepIds.reviewSchedule"
                        [heading]="'Monitor.briefings.stepsNavigation.review'"
                    >
                        <agpr-briefing-review-step
                            [reservedUrl]="reservedUrl"
                            [draftPublished]="draftPublished"
                            [compositionErrors]="compositionErrors"
                            [publishingErrors]="publishingErrors"
                            [schedulingError]="schedulingError"
                            [publishDraftInProgress]="publishDraftInProgress"
                            [numAutoGenMentions]="numAutoGenMentions"
                            (publishDraft)="publishDraft()"
                            (changeStep)="changeStep($event)"
                        ></agpr-briefing-review-step>
                    </agpr-tab>
                    @if (briefing.isPreviewMode && currentStep === briefingSteps.compose) {
                        <div globalBanner class="agpr-briefing-bannerMessage">
                            <agpr-message
                                [severity]="messageSeverityEnum.info"
                                [bannerIcon]="true"
                                [autoFit]="true"
                            >
                                {{ 'Briefings.previewMode.banner.message' | localize }}&nbsp;<agpr-button class="agpr-briefing-expertModeLink" [style]="buttonTypes.link" (click)="switchToExpertMode()" label="Briefings.previewMode.banner.expertMode"></agpr-button>.
                            </agpr-message>
                        </div>
                    }
                </agpr-briefing-steps-navigation>

                @if (autoGensStatus && !autoGensStatus.showDialog && autoGensStatus?.loading) {
                    <div class="agpr-briefing-bannerMessage">
                        <agpr-message
                            [severity]="messageSeverityEnum.warning"
                            [bannerIcon]="true"
                            [toggleable]="true"
                            [collapsed]="true"
                            [closeable]="false"
                            [autoFit]="true"
                            [toggleableContent]="autoGenBannerMessage"
                            [showBannerMessage]="true"
                            (collapsedChange)="toggleAutoGenExpanded($event)"
                        >
                            {{
                                ('Briefings.blockType.autoGeninsights.mentionsLoadingHeader' | localize : {
                                    count: autoGensStatus?.count || 0, totalInsightsToComplete: autoGensStatus?.stats?.totalInsightsToComplete || 0
                                })
                            }}

                            <ng-template #autoGenBannerMessage>
                                <div
                                    class="agpr-briefing-autoGenInfoList"
                                    [ngClass]="{'agpr-briefing-errorList--hidden': !isAutoGenBannerExpanded}"
                                >
                                    <ul>
                                        <li class="agpr-curatedAutoWebsocketDialog-content-info">
                                            {{ 'Briefings.blockType.autoGeninsights.takeSeveralMinutes' | localize }}
                                        </li>
                                        <li>
                                            {{ 'Briefings.blockType.autoGeninsights.pleaseNote' | localize }}
                                        </li>
                                    </ul>
                                </div>
                            </ng-template>
                        </agpr-message>
                    </div>
                }

                @if (precisionClipProcess && precisionClipProcess.status === 'pending') {
                    <div class="agpr-briefing-bannerMessage">
                        <agpr-message
                            [severity]="messageSeverityEnum.info"
                            [autoFit]="true"
                            [showBannerMessage]="true"
                        >
                            <div class="agpr-briefing-bannerMessage-row">
                                <span> {{
                                    'Briefings.blockType.precisionClip.progress' | localize: {
                                        count: precisionClipProcess.clipsCompleted || 0,
                                        totalInsightsToComplete: precisionClipProcess.totalClipsToComplete || 0
                                    }
                                    }}
                                </span>
                                <agpr-button
                                    [id]="id + '_precisionClipBanner_cancelButton'"
                                    class="agpr-briefing-updatePreviewLink"
                                    [style]="buttonTypes.link"
                                    label="Monitoring.cancel"
                                    (click)="cancelPrecision()"
                                ></agpr-button>
                            </div>
                        </agpr-message>
                    </div>
                }

                @if (briefing.isPreviewMode && briefing.canvasPreview?.isChanged) {
                    <div class="agpr-briefing-bannerMessage">
                        <agpr-message
                            [severity]="messageSeverityEnum.warning"
                            [autoFit]="true"
                            [closeable]="true"
                            (dismiss)="dismissCanvasChangedBanner()"
                        >
                            {{ 'Briefing.canvas.pendingChanges.message' | localize }}&nbsp;<agpr-button class="agpr-briefing-updatePreviewLink" [style]="buttonTypes.link" (click)="generatePreview()" label="Briefing.canvas.pendingChanges.updatePreview"></agpr-button>
                        </agpr-message>
                    </div>
                }
                @if (
                    briefing.status !== briefingStatus.SENT &&
                    !(briefing.status === briefingStatus.SCHEDULED && briefing.sendAt.sendNow)
                    && !isSending
                ) {
                    <agpr-action-bar
                        [headingContext]="'Monitor.leftSideBar.briefings.itemsHeading' | localize"
                    >
                        <ng-template #left>
                            @if (currentStep !== briefingSteps.compose) {
                                <agpr-button
                                    [id]="id + '_briefingPreviousStepButton'"
                                    label="Briefing.backButtonLabel"
                                    (click)="changeStep(currentStep - 1)"
                                    [style]="buttonTypes.secondary"
                                ></agpr-button>
                            }
                            @if (
                                briefingCuratedMentions.length > 0
                                && (
                                    briefing.status === briefingStatus.ACTIVE
                                    || briefing.status === briefingStatus.CANCELLED
                                    || briefing.status === briefingStatus.DRAFT
                                )
                                && currentStep === briefingSteps.compose
                            ) {
                                <agpr-button
                                    [id]="id + '.briefingRemoveAllMentionsButton'"
                                    label="Briefing.removeAllMentionsButtonLabel"
                                    [style]="buttonTypes.secondary"
                                    (click)="removeAllMentions()"
                                ></agpr-button>
                            }
                            @if (mentionsSelected && selectedTabIndex === sortToolTabIndex) {
                                <agpr-button
                                    [id]="id + '.briefingRemoveFromBriefingButton'"
                                    label="Remove From Briefing"
                                    [style]="buttonTypes.secondary"
                                    (click)="briefingComposeTab.sortTool.delete()"
                                ></agpr-button>
                            }
                        </ng-template>
                        <ng-template #right>
                            @if (briefing.isPreviewMode) {
                                <agpr-button
                                    [id]="id + '_briefingExpertModeButton'"
                                    label="Briefings.previewMode.expertMode.button"
                                    [style]="buttonTypes.primaryB"
                                    (click)="switchToExpertMode()"
                                ></agpr-button>
                            }
                            @if (!isClean) {
                                @if (briefing.status === briefingStatus.PAUSED || briefing.status === briefingStatus.ACTIVE) {
                                    <agpr-button
                                        [id]="id + '.briefingUpdateButton'"
                                        label="Briefing.updateButtonLabel"
                                        [loading]="saveInProgress"
                                        [style]="buttonTypes.primaryB"
                                        (click)="update()"
                                    ></agpr-button>
                                } @else if (!briefing?.id && (briefing.status === briefingStatus.CANCELLED || briefing.status === briefingStatus.DRAFT)) {
                                    <!-- show save button (hide split button) when there is no briefing ID aka new briefing -->
                                    <agpr-button
                                        [id]="id + '.briefingSaveAsDraftButton'"
                                        label="Briefing.saveAsDraftButtonLabel"
                                        [loading]="saveInProgress"
                                        [style]="buttonTypes.primaryB"
                                        [disabled]="!canSaveBriefing"
                                        (click)="saveAsDraft()"
                                    ></agpr-button>
                                }
                            }

                            @if (briefing?.id && (briefing.status === briefingStatus.CANCELLED || briefing.status === briefingStatus.DRAFT)) {
                                <!-- show split button (hide save button) when there is briefing ID -->
                                <agpr-split-button
                                    [id]="id + '_briefingActionButtons'"
                                    label="actions"
                                    panelPositionY="top"
                                    panelPositionX="right"
                                    [loading]="saveInProgress"
                                    [disabled]="saveInProgress || (!hasDynamicElements && (!canSaveBriefing || isClean))"
                                    [options]="actions"
                                    [caretDown]="false"
                                ></agpr-split-button>
                            }

                            @if (
                                isScheduled
                                && (
                                    briefing.sendAt?.sendNow === false
                                    || briefing.sendAt?.sendNow === null
                                )
                            ) {
                                <agpr-button
                                    [id]="id + '.briefingCancelScheduledBriefingButton'"
                                    label="Briefing.cancelButtonLabel"
                                    (click)="cancel()"
                                ></agpr-button>
                            }
                            @if (isClean && briefing.status === briefingStatus.ACTIVE) {
                                <agpr-button
                                    [id]="id + '.briefingPauseCurrentBriefingButton'"
                                    label="Briefing.pauseButtonLabel"
                                    (click)="briefingsService.pauseCurrentBriefing()"
                                ></agpr-button>
                            }
                            @if (
                                currentStep === briefingSteps.reviewSchedule
                                && (
                                    briefing.status === briefingStatus.CANCELLED
                                    || briefing.status === briefingStatus.DRAFT
                                    || (
                                        briefing.status === briefingStatus.PAUSED
                                        && isClean
                                    )
                                )
                            ) {
                                @if (deliverySchedulerInputFields.schedulingType !== deliveryTypes.recurring) {
                                    <agpr-button
                                        [id]="id + '.briefingSendBriefingButton'"
                                        label="Briefing.sendButtonLabel"
                                        [loading]="submitInProgress"
                                        [disabled]="showErrors || publishDraftInProgress"
                                        [style]="buttonTypes.primary"
                                        (click)="send()"
                                    ></agpr-button>
                                } @else {
                                    <agpr-button
                                        [id]="id + '.briefingStartRecurringBriefingButton'"
                                        label="Briefing.startButtonLabel"
                                        [disabled]="showErrors"
                                        (click)="start()"
                                        [style]="buttonTypes.primary"
                                    ></agpr-button>
                                }
                            }
                            @if (currentStep !== briefingSteps.reviewSchedule) {
                                <agpr-button
                                    [id]="id + '_briefingNextStepButton'"
                                    label="Briefing.nextButtonLabel"
                                    (click)="changeStep(currentStep + 1)"
                                    [style]="buttonTypes.primary"
                                ></agpr-button>
                            }

                        </ng-template>
                    </agpr-action-bar>
                }
            </section>
            <aside
                class="agpr-briefing-sidebar"
                [attr.aria-label]="'Common.layout.rhp' | localize"
            >
                @if (briefing.isPreviewMode) {
                    <agpr-right-sidebar
                        [(selectedTabIndex)]="selectedTabIndex"
                        (selectedTabIndexChange)="rhpTabChange()"
                    >
                        <agpr-tab
                            [id]="id + '.briefingComponentSliders'"
                            icon=" fa-sliders"
                            [tabTitle]="'Briefings.previewMode.rhp.setup'"
                            [tooltip]="'Briefings.previewMode.rhp.setup'"
                        >
                            <agpr-briefing-canvas-template-setup
                                [id]="id"
                                [canvasPreview]="briefing.canvasPreview"
                                (changes)="canvasSetupChanged()"
                            ></agpr-briefing-canvas-template-setup>
                            <ng-template #tabFooter>
                                @if (hasOpenAI && hasCoverageInsights) {
                                    <agpr-copilot-switch-banner
                                        [title]="'Briefing.onlineBriefing.template.switchBanner.title'"
                                        [description]="'Briefing.onlineBriefing.template.openAiDescription' | localize"
                                        [(ngModel)]="briefing.canvasPreview.allowAi"
                                        (ngModelChange)="canvasSetupChanged()"
                                        [variant]="copilotSwitchBannerVariantEnum.card"
                                        [isCollapsed]="true"
                                    ></agpr-copilot-switch-banner>
                                }
                                <agpr-action-bar>
                                    <ng-template #right>
                                        @if (editable) {
                                            <agpr-button
                                                [id]="id + '.canvasSetup.saveTemplate'"
                                                label="Briefing.saveAsTemplateLabel"
                                                [style]="buttonTypes.tertiary"
                                                (click)="saveAsCanvasTemplate()"
                                            ></agpr-button>
                                        }
                                        <agpr-button
                                            [id]="id + '.canvasSetup.generatePreview'"
                                            label="Briefing.canvas.generatePreview"
                                            [style]="buttonTypes.tertiary"
                                            (click)="generatePreview()"
                                        ></agpr-button>
                                    </ng-template>
                                </agpr-action-bar>
                            </ng-template>
                        </agpr-tab>
                        <agpr-tab
                            [id]="id + '.briefingComponentCustomize'"
                            icon="fa-paintbrush"
                            [tooltip]="'Briefings.canvas.rhp.customize'"
                        >
                            <agpr-briefing-canvas-customize
                                [canvasPreview]="briefing.canvasPreview"
                                [id]="id"
                                (changes)="canvasSetupChanged()"
                            ></agpr-briefing-canvas-customize>
                            <ng-template #tabFooter>
                                <agpr-action-bar>
                                    <ng-template #right>
                                        <agpr-button
                                            [id]="id + '.canvasCustomize.apply'"
                                            label="Briefing.canvas.customize.apply"
                                            [style]="buttonTypes.tertiary"
                                            (click)="applyCanvasCustomize()"
                                        ></agpr-button>
                                    </ng-template>
                                </agpr-action-bar>
                            </ng-template>
                        </agpr-tab>
                        <agpr-tab
                            [id]="'briefingDetailsTab'"
                            icon=" fa-file-lines"
                            [showSpacer]="currentStep === briefingSteps.compose"
                            [tooltip]="'Briefing.canvasDetails'"
                        >
                            <ng-container *ngTemplateOutlet="briefingDetailsContent"></ng-container>
                        </agpr-tab>
                    </agpr-right-sidebar>
                } @else {
                    <agpr-right-sidebar
                        [(selectedTabIndex)]="selectedTabIndex"
                        (selectedTabIndexChange)="rhpTabChange()"
                    >
                        <ng-template #footer>
                            <agpr-action-bar
                                [headingContext]="'Monitor.briefings.draft' | localize"
                                [headingLevel]="4"
                            >
                                <ng-template #right>
                                    @if (editable && briefing.id && isClean && (briefing?.deliveryMethod !== deliveryMethods.ONLINE)) {
                                        <agpr-button
                                            [id]="id + '.briefingPreviewButton'"
                                            label="Briefing.preview"
                                            [style]="buttonTypes.tertiary"
                                            (click)="preview()"
                                        ></agpr-button>
                                        <agpr-button
                                            [id]="id + '.briefingSaveTemplateButton'"
                                            label="Briefing.saveAsTemplateLabel"
                                            [style]="buttonTypes.tertiary"
                                            (click)="saveAsTemplate()"
                                        ></agpr-button>
                                    }
                                    @if (editable && briefing?.deliveryMethod === deliveryMethods.ONLINE) {
                                        <agpr-button
                                            [id]="id + '.compose.saveTemplate'"
                                            label="Briefing.saveAsTemplateLabel"
                                            [style]="buttonTypes.tertiary"
                                            (click)="saveAsCanvasTemplate()"
                                        ></agpr-button>
                                    }
                                    @if (selectedBlock && selectedTabIndex === blockFormTabIndex) {
                                        <agpr-button
                                            label="Briefing.apply"
                                            [id]="id + '.briefingApplyChangesButton'"
                                            [style]="buttonTypes.tertiary"
                                            (click)="briefingsService.confirmChangesToSelectedBlock()"
                                        ></agpr-button>
                                    }
                                </ng-template>
                            </agpr-action-bar>
                        </ng-template>
                        @if (currentStep === briefingSteps.compose) {
                            <agpr-tab
                                [id]="id + '.briefingComponentSliders'"
                                icon=" fa-sliders"
                                [tabTitle]="briefing?.deliveryMethod !== deliveryMethods.ONLINE ? 'Briefings.rhp.setup' : 'Briefings.canvas.rhp.setup'"
                                [tooltip]="briefing?.deliveryMethod !== deliveryMethods.ONLINE ? 'Briefings.rhp.setup' : 'Briefings.canvas.rhp.setup'"
                            >
                                @if (editable) {
                                    <div class="agpr-briefing-addMentions">
                                        <agpr-split-button
                                            class="agpr-briefing-addCoverageButton"
                                            [id]="id + '_addMentionsButton'"
                                            [style]="buttonTypes.primaryB"
                                            icon='fa-regular fa-duotone fa-square-plus'
                                            [options]="addMentionsActions"
                                            [label]="'Briefings.addCoverage' | localize"
                                            panelPositionY="bottom"
                                            [disabled]="!mentionBlockType.canAdd"
                                            [tooltip]="mentionBlockType.canAdd ? '' : 'Briefing.blocks.reachLimit.general'"
                                        ></agpr-split-button>
                                    </div>
                                    <div class="agpr-briefing-mentionCount">
                                        @if (allocatedMentionsCount > 0 && allocatedMentionsCount / maxNumberOfMentionsInBriefing < 0.75) {
                                            <agpr-message [severity]="messageSeverityEnum.info">
                                                <span class="agpr-briefing-mentionCount-highlight">{{ allocatedMentionsCount + '/' + maxNumberOfMentionsInBriefing }}</span>
                                                <span>{{ 'Briefings.addCoverage.mentionsAdded' | localize }}</span>
                                            </agpr-message>
                                        }

                                        @if (allocatedMentionsCount / maxNumberOfMentionsInBriefing > 0.75 && allocatedMentionsCount <= maxNumberOfMentionsInBriefing) {
                                            <agpr-message [severity]="messageSeverityEnum.warning">
                                                <span class="agpr-briefing-mentionCount-highlight">{{ allocatedMentionsCount + '/' + maxNumberOfMentionsInBriefing}}</span>
                                                <span>{{ 'Briefings.addCoverage.mentionsAdded' | localize }}</span>
                                            </agpr-message>
                                        }

                                        @if (allocatedMentionsCount > maxNumberOfMentionsInBriefing) {
                                            <agpr-message [severity]="messageSeverityEnum.error">
                                                <span class="agpr-briefing-mentionCount-highlight">{{ allocatedMentionsCount + '/' + maxNumberOfMentionsInBriefing}}</span>
                                                <span>{{ 'Briefings.addCoverage.mentionsAdded' | localize }}</span>
                                            </agpr-message>
                                        }

                                        <div class="agpr-briefing-mentionCount">
                                            @if (numAutoGenMentions > 100) {
                                                <agpr-message
                                                    [severity]="messageSeverityEnum.warning"
                                                    [agprTooltip]="'Briefings.blockType.autoGeninsights.limitFeedback.tooltip'"
                                                >
                                                    {{ 'Briefings.blockType.autoGeninsights.limitFeedback' | localize }}
                                                </agpr-message>
                                            }
                                        </div>
                                    </div>
                                    <agpr-panel
                                        [header]="briefing?.deliveryMethod !== deliveryMethods.ONLINE ? 'Briefings.sidebar.headingComponents' : 'Briefings.canvas.sidebar.headingComponents'"
                                        [contentPadding]="!briefingsService.isBlockLimitExceeded"
                                    >
                                        @if (briefingsService.isBlockLimitExceeded) {
                                            <agpr-message class="agpr-briefing-blockLimitBanner" [severity]="messageSeverityEnum.warning">
                                                {{ 'Briefing.totalBlocks.limitExceeded.banner' | localize }}
                                            </agpr-message>
                                        }
                                        <agpr-block-adder
                                            [id]="id + '_blockAdder'"
                                            [draggable]="true"
                                        ></agpr-block-adder>
                                    </agpr-panel>
                                    <agpr-panel header="Briefings.sidebar.layouts">
                                        <agpr-layout-block-adder
                                            [id]="id + '_layoutBlockAdder'"
                                            [draggable]="true"
                                        ></agpr-layout-block-adder>
                                    </agpr-panel>
                                }
                            </agpr-tab>
                            @if (currentStep === briefingSteps.compose) {
                                <agpr-tab
                                    #blockFormTab
                                    [id]="id + '.briefingComponentblockFormTab'"
                                    icon=" fa-wrench"
                                    tooltip="Briefings.rhp.blockEdit"
                                    [disabled]="!selectedBlock || !editable"
                                >
                                    <agpr-block-form></agpr-block-form>
                                </agpr-tab>
                                <agpr-tab
                                    [id]="id + '.briefingComponentOrganize'"
                                    icon=" fa-arrow-down-arrow-up"
                                    tooltip="Briefings.rhp.organize"
                                    [disabled]="!editable"
                                >
                                    <div class="agpr-briefing-addMentions">
                                        <agpr-split-button
                                            [id]="id + '_addMentionsButton'"
                                            class="agpr-briefing-addCoverageButton"
                                            [style]="buttonTypes.primaryB"
                                            icon='fa-regular fa-duotone fa-square-plus'
                                            [options]="addMentionsActions"
                                            [label]="'Briefings.addCoverage' | localize"
                                        ></agpr-split-button>
                                    </div>
                                    @if (selectedTabIndex === sortToolTabIndex) {
                                        <agpr-sort-tool-right-sidebar
                                            [id]="id + 'sortToolRightSidebar'"
                                            [sortTool]="briefingComposeTab.sortTool"
                                            (selectBlockEditTab)="selectBlockEditTab()"
                                            [draggingMentions]="draggingMentions"
                                        ></agpr-sort-tool-right-sidebar>
                                    }
                                </agpr-tab>
                                <agpr-tab
                                    [id]="id + '.briefingComponentCustomize'"
                                    icon=" fa-paintbrush"
                                    [tooltip]="briefing?.deliveryMethod !== deliveryMethods.ONLINE ? 'Briefings.rhp.customize' : 'Briefings.canvas.rhp.customize'"
                                    [disabled]="!editable"
                                >
                                    <agpr-briefing-global-customization
                                        [id]="id + '.briefingGlobalCustomization'"
                                        (change)="briefingChanged()"
                                    ></agpr-briefing-global-customization>
                                </agpr-tab>
                                @if (!briefing?.sendAt?.recurring && (briefing?.deliveryMethod === deliveryMethods.ONLINE) && briefing?.id) {
                                    <agpr-tab
                                        [id]="'briefingPdfTab'"
                                        icon="fa-file-pdf"
                                        [heading]="'Briefing.pdf.generate'"
                                        [tooltip]="'Briefing.pdf'"
                                    >
                                        <agpr-message [severity]="messageSeverityEnum.info">
                                            {{ 'briefing.pdf.warning' | localize}}
                                        </agpr-message>

                                        <agpr-checkbox
                                            [id]="'briefing.pdf.includeMentions'"
                                            class="agpr-checkbox-"
                                            [value]="includeMentionsInPDF"
                                            [infoCircleTooltip]="'Briefing.pdf.includeMentions.tooltip'"
                                            [label]="'Briefing.pdf.includeMentions'"
                                            [binary]="true"
                                            [(ngModel)]="includeMentionsInPDF"
                                        ></agpr-checkbox>

                                        <div class="agpr-briefing-generatePDF">
                                            <agpr-button
                                                [id]="id + '.briefingDownloadPDFButton'"
                                                label="Briefing.pdf.generate"
                                                [disabled]="generatingPDF || publishDraftInProgress"
                                                [loading]="generatingPDF"
                                                [style]="buttonTypes.tertiary"
                                                (click)="generatePDF()"
                                            ></agpr-button>
                                        </div>
                                    </agpr-tab>
                                }
                            }
                        }

                        <agpr-tab
                            [id]="'briefingDetailsTab'"
                            icon=" fa-file-lines"
                            [showSpacer]="currentStep === briefingSteps.compose"
                            [tooltip]="briefing?.deliveryMethod !== deliveryMethods.ONLINE ? 'Briefing.briefingDetails' : 'Briefing.canvasDetails'"
                        >
                            <ng-container *ngTemplateOutlet="briefingDetailsContent"></ng-container>
                        </agpr-tab>
                    </agpr-right-sidebar>
                }
            </aside>
        </div>
    </main>
}

<ng-template #briefingDetailsContent>
    @if (!isScheduled) {
        <agpr-attribute-list
            [attributes]="briefingDetails"
        >
        </agpr-attribute-list>
    } @else {
        <agpr-attribute-list
            [attributes]="sentDetails"
        >
        </agpr-attribute-list>
    }
    @if (!briefing.sendAt.recurring) {
        <div class="agpr-briefing-sidebar-reservedUrl">
            <agpr-attribute-list
                [attributes]="reservedUrlDetails"
            >
            </agpr-attribute-list>
        </div>
    }
</ng-template>
<ng-template let-feed #rssFeedDisclaimer>
    @if (feed) {
        <div class="agpr-briefing-rssFeedDisclaimer">
            <span> {{ feed.name }} </span>
            <span class="fa fa-rss agpr-briefing-rssFeedDisclaimer-icon" aria-hidden="true"></span>
            <a class="agpr-briefing-rssFeedDisclaimer-link" [href]="feed.url" target="_blank"> {{ feed.url }} </a>
        </div>
    }
</ng-template>
<ng-template let-feed let-copyUrl="copyUrl" let-message="message" #rssFeedSentDetails>
    @if (feed) {
        <div class="agpr-briefing-rssFeedSent">
            <p> {{ feed.name }} </p>
            <div class="agpr-briefing-rssFeedSent-linkContainer">
                <span class="fa fa-rss agpr-briefing-rssFeedSent-linkContainer-icon" aria-hidden="true"></span>
                <a class="agpr-briefing-rssFeedSent-linkContainer-link" [href]="feed.url" target="_blank"> {{ feed.url }} </a>
                <agpr-button
                    [style]="buttonTypes.icon"
                    icon="fa-kit-duotone fa-agpr-copy"
                    tooltip="Reports.sharedReports.rhp.copyUrl"
                    tooltipPosition="top"
                    (click)="copyUrl($event, feed.url, message)"
                ></agpr-button>
            </div>
        </div>
    }
</ng-template>
